import GuidesManager from "./GuidesManager";

export default class Guides extends GuidesManager {}
